<template>
  <div class="gallery-section">
    <swiper
        :slides-per-view="1"
        :space-between="50"
        @swiper="onSwiper"
        @slideChange="onSlideChange"
        :loop="true"
        :scrollbar="{ draggable: true }"
    >
      <template v-for="(picture, index) in sortedMedia">
        <swiper-slide style="background: url(/assets/images/product-image-bg.jpg) no-repeat; background-size: contain;">
          <NuxtImg format="webp" provider="ipx" laoding="lazy"  alt="product-gallery" @click="openLargeImage(picture?.media?.url)" :src="picture?.media?.url" width="533" />
        </swiper-slide>
      </template>
    </swiper>

    <div class="navigation">
      <span
        v-for="(picture, index) in sortedMedia"
        :key="'nav-' + index"
        class="nav-dot"
        :class="{ active: index === currentIndex }"
        @click="goToSlide(index)"
      >
        <img :src="picture?.media?.url" />
      </span>
    </div>
  </div>

  <SharedModal :controller="productImagePopUp" popupClass="popup-large-image">
    <ProductImagePopup
        :ImageUrl="imageUrlLarge"
        @close="productImagePopUp.close"
    />
  </SharedModal>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import ProductImagePopup from "~/components/cms/ProductImagePopup.vue";
import { rearrangeArray } from "~/components/utilities";
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';

const props = defineProps<{
  media: Array<any>[];
  additionalMedia: Array<any>[];
}>();

const currentIndex = ref(0);
const imageUrlLarge = ref('')
const sortedMedia = ref([])

const productImagePopUp = useModal();

const openLargeImage = (imageUrl: any)=> {
  imageUrlLarge.value = imageUrl
  productImagePopUp.open()
}

let SwiperInstance = null;

const onSwiper = (swiper) => {
  SwiperInstance = swiper;
};

const onSlideChange = () => {
  if(SwiperInstance) {
    currentIndex.value = SwiperInstance.activeIndex;
  }
};

const goToSlide = (index: number) => {
  currentIndex.value = index;
  SwiperInstance.slideTo(index);
};

onMounted( ()=> {
  sortedMedia.value = props.media.sort((a, b) => a.position > b.position ? 1 : -1);

  props.additionalMedia.forEach((item) => {
    sortedMedia.value.push(item)
  });
})

</script>
